import { AssessmentDecision } from '@/gen/inventory/v1/assessment_decision_pb'

import { assessmentDecisionLabel } from '@/const/label'

import { Badge, BadgeProps } from '@/components/lemmala-design-system/badge/badge'
import { AssessmentDecisionIcon } from '@/components/shared/icons/assessment-decision'

const assessmentDecisionToVariant: Record<AssessmentDecision, BadgeProps['variant']> = {
  [AssessmentDecision.APPROVED]: 'success',
  [AssessmentDecision.CONDITIONALLY_APPROVED]: 'warning',
  [AssessmentDecision.REJECTED]: 'danger',
  [AssessmentDecision.UNSPECIFIED]: 'neutral',
}

type AssessmentDecisionBadgeProps = {
  decision: AssessmentDecision
  disableIcon?: boolean
}

export const AssessmentDecisionBadge = ({
  decision,
  disableIcon = false,
}: AssessmentDecisionBadgeProps) => {
  const label = assessmentDecisionLabel[decision]
  const variant = assessmentDecisionToVariant[decision]

  return (
    <Badge variant={variant} badgeStyle='subtle' textCase='title' className='w-fit'>
      {!disableIcon && <AssessmentDecisionIcon decision={decision} />}
      <span className='text-nowrap'>{label}</span>
    </Badge>
  )
}
